import { Business as BusinessIcon } from '@mui/icons-material';
import { Box, Paper, Stack, Typography } from '@mui/material';
import React from 'react';

export interface ClientInfoProps {
  identifier: string;
  businessName?: string;
}

const ClientInfo: React.FC<ClientInfoProps> = ({
  identifier,
  businessName,
}) => {
  if (!identifier) return null;

  return (
    <Paper
      sx={{
        p: '12px',
        boxShadow: 'none',
        border: '1px solid #e0e0e0',
        mb: 2,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box
          sx={{
            backgroundColor: 'primary.main',
            borderRadius: '50%',
            p: 0.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
          }}
        >
          <BusinessIcon sx={{ fontSize: '1rem' }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          {businessName ? (
            <>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                  fontSize: '1rem',
                  lineHeight: 1.1,
                }}
              >
                <strong>Empresa:</strong> {businessName}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                <strong>RUT:</strong> {identifier}
              </Typography>
            </>
          ) : (
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: 'text.primary',
                fontSize: '1rem',
                lineHeight: 1.1,
              }}
            >
              <strong>RUT:</strong> {identifier}
            </Typography>
          )}
        </Box>
      </Stack>
    </Paper>
  );
};

export default ClientInfo;
